<template>
  <main class="unbind-detail-page">
    <AppNavBar
      :title="t('card.unBindCardText_19')"
      background-color="#f7f7f7"
    />

    <section class="detail-card">
      <div class="detail-row">
        <span>{{ t("card.cardType") }}:</span>
        <div data-strong>{{ detail.network || "" }}</div>
      </div>
      <div class="dash-line" />

      <div class="detail-row">
        <span>{{ t("card.cardNumber") }}:</span>
        <div data-strong>{{ detail.maskedPan || "" }}</div>
      </div>
      <div class="dash-line" />

      <div class="detail-row">
        <span>{{ t("card.unbindCardStatus") }}:</span>
        <div data-strong>{{ t("card.unBindCardText_18") }}</div>
      </div>
      <div class="dash-line" />

      <div class="detail-row">
        <span>{{ t("card.unBindCardText_20") }}</span>
        <div data-strong>
          {{ String(detail.balance ?? "") + (detail.symbol || "USD") }}
        </div>
      </div>

      <template v-if="Number(detail.balance || 0) !== 0">
        <div class="dash-line" />
        <div class="detail-row">
          <span>{{ t("card.unBindCardText_21") }}</span>
          <div data-strong>
            {{
              detail.isRefund === true
                ? t("card.unbindRefundYes")
                : t("card.unbindRefundPending")
            }}
          </div>
        </div>
      </template>

      <div class="dash-line" />
      <div class="detail-row">
        <span>{{ t("card.unBindCardText_22") }}</span>
        <div data-strong>{{ detail.createTime || "" }}</div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { pcCardCancelDetail } from "@/api/card";
import { getRouteState } from "@/utils/route-state";

const { t } = useI18n();
const route = useRoute();
const pageState = getRouteState(route, "card-unbind-detail", {});
const detail = ref({});

const loadDetail = async () => {
  if (!pageState.id) return;
  try {
    detail.value = await pcCardCancelDetail({ id: pageState.id });
  } catch (error) {
    detail.value = {};
  }
};

onMounted(loadDetail);
</script>

<style scoped lang="scss">
.unbind-detail-page {
  min-height: var(--app-viewport-height);
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  background: #f7f7f7;
}

.detail-card {
  margin: 20px 20px 0;
  padding: 16px;
  border-radius: 8px;
  background: #ffffff;
}

.detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
  gap: 12px;
  color: #333333;
  font-size: 14px;

  div {
    color: #000000;
    text-align: right;
    word-break: break-all;
  }
}

.dash-line {
  width: 100%;
  height: 1px;
  margin: 12px 0 16px;
  border-bottom: 1px dashed #e0e0e0;
}
</style>
